export default {
  table: {
    '& th': {
      textAlign: 'left'
    }
  },
  permissionCell: {
    textAlign: 'center !important'
  }
}
